import { auth } from "../firebase";
import ENV from "../env";

const importExternalParticipants = async ({
  eventId,
  orgId,
  provider,
  externalImportId,
  ignoredInvalidCount = 0,
  participants,
}) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Authentication required");

  const response = await fetch(`${ENV.firebaseApiUrl}/ticketing/import-external-participants`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      eventId,
      orgId,
      provider,
      externalImportId,
      ignoredInvalidCount,
      participants,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || "External participant import failed");
  }
  return data;
};

export default importExternalParticipants;
